import parse from "html-react-parser";
import type { ReactNode } from "react";
import { sanitizeHtml } from "../../utils/sanitize";

type Props = {
  /** HTML cru. `null`, `undefined` ou string vazia renderizam `null`. */
  html: string | null | undefined;
};

/**
 * Renderiza HTML cru como árvore de `ReactNode` real via
 * `html-react-parser`, sem `dangerouslySetInnerHTML` e sem wrapper opinado.
 *
 * @example
 * ```tsx
 * <div className="rich-text-reset-html">
 *   <DynamicRichText html={entry.body} />
 * </div>
 * ```
 */
export function DynamicRichText({ html }: Props): ReactNode {
  if (!html) return null;
  return <>{parse(sanitizeHtml(html))}</>;
}
